import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import error from "../../utils/error";
import ConnectionServices, { IConnectionInfo } from "../../services/connectionApi";

interface IConnectionPageState {
  list: {
    isLoading: boolean,
    status: string,
    data: IConnectionInfo[],
    error?: string
  },
  save: {
    isSaving: boolean,
    isDeleting: boolean,
    error?: string,
    responseData? : any[]
  },
}

const initialConnectionState: IConnectionPageState = {
  list: {
    isLoading: false,
    status: "",
    data: [],
    error: undefined
  },
  save: {
    isSaving: false,
    isDeleting: false,
    error: undefined,
    responseData: [],
  }
};

export const addConnection = createAsyncThunk(
  "connection/addConnection",
  async (payload: IConnectionInfo) => {
    try {
      return ConnectionServices.addConnection(payload);
    } catch (error_) {
      return error_;
    }
  }
);

export const getConnectionList = createAsyncThunk(
  "connection/getConnectionList",
  async () => {
    try {
      return ConnectionServices.getConnectionList();
    } catch (error_) {
      return error_;
    }
  }
);

const connectionSlice = createSlice({
  name: "connection",
  initialState: initialConnectionState,
  reducers: {},
  extraReducers(builder): void {
    builder.addCase(addConnection.pending, (state) => {
      state.save.isSaving = true;
    });
    builder.addCase(addConnection.fulfilled, (state, action) => {
      state.save.isSaving = false;
      state.save.responseData = action.payload;
    });
    builder.addCase(addConnection.rejected, (state, action) => {
      state.save.isSaving = false;
      // action.payload contains error information
      state.save.error = error(action.payload);
    });

    builder.addCase(getConnectionList.pending, (state) => {
      state.list.isLoading = true;
    });
    builder.addCase(getConnectionList.fulfilled, (state, action) => {
      state.list.isLoading = false;
      state.list.data = action.payload;
    });
    builder.addCase(getConnectionList.rejected, (state, action) => {
      state.list.isLoading = false;
      // action.payload contains error information
      state.list.error = error(action.payload);
    });
  },
});

export default connectionSlice.reducer;
